exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".media-player[data-v-198dcb20]{position:relative;height:37px;padding:5px;text-align:center}.media-player div.progress-call[data-v-198dcb20]{position:absolute;top:0;left:0;border:1px solid grey;width:100%;height:34px;border-radius:6px}.media-player div.buttons-call[data-v-198dcb20]{position:absolute}.media-player div.buttons-call .media-icon[data-v-198dcb20]{height:24px;width:28px;border-radius:3px;box-shadow:none!important;background-color:#fff!important;border:1px solid #999;color:#337ab7;float:left;padding:4px}", ""]);

// exports
